import { Button } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Modal from '~/components/Modal';
import { PREFIX_ROUTE } from '~/constants';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';

const BuyPackageModal = () => {
  const { t } = useTranslation('app');
  const { locale } = useParams();
  const dispatch = useDispatch();

  return (
    <Modal modalKey="buyPackageModal" title={t('publishListing')}>
      <div className="flex flex-col gap-3x pb-4x w-full">
        <div className="flex flex-col gap-x">
          <p className="text-title_4 text-gray__dark_2">{t('')}</p>
          <p className="text-body_2 ">{t('buyPackageDesc')}</p>
        </div>
        <div className="flex gap-1.5x">
          <Link
            to={`${process.env.REACT_APP_BASE_URL}/${locale}/${PREFIX_ROUTE}/packages`}
            target="_blank"
            className="flex-1 !text-link"
          >
            <Button
              size="medium"
              variant="primary"
              className="flex-1 !text-link w-full"
            >
              {t('buyPackage')}
            </Button>
          </Link>
          <Button
            size="medium"
            variant="secondary"
            className="!text-link"
            onClick={() => dispatch(closeModal('buyPackageModal'))}
          >
            {t('cancel')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BuyPackageModal;
